import type { ChatMessage } from '../models/chat-message';
import type {
  BotBlock,
  BotField,
  BotFieldEntry,
  BotFieldsGroup,
  BotKnownBlock,
  BotKnownField,
  BotNotice,
  BotPanel,
  BotRecord,
  BotView,
} from '../models/bot-widget';

const BOT_PANEL_TYPES = new Set<string>([
  'bot.prompt',
  'bot.help',
  'bot.picker',
]);

const KNOWN_FIELD_TYPES = new Set<string>([
  'text',
  'status',
  'link',
  'number',
  'money',
  'duration',
  'boolean',
  'date',
  'datetime',
  'image',
  'identifier',
]);

const KNOWN_BLOCK_KINDS = new Set<string>([
  'fields',
  'rows',
  'text',
  'media',
  'tags',
  'actions',
]);

export function isBotPanel(widget: ChatMessage['widget']): widget is BotPanel {
  return !!widget && BOT_PANEL_TYPES.has(widget.type);
}

export function isBotRecord(
  widget: ChatMessage['widget'],
): widget is BotRecord {
  return widget?.type === 'bot.record';
}

export function isBotView(widget: ChatMessage['widget']): widget is BotView {
  return widget?.type === 'bot.view';
}

export function isBotNotice(
  widget: ChatMessage['widget'],
): widget is BotNotice {
  return widget?.type === 'bot.notice';
}

export function isBotFieldsGroup(
  entry: BotFieldEntry,
): entry is BotFieldsGroup {
  return 'block' in entry && entry.block === 'fields';
}

export function isKnownBotField(field: BotField): field is BotKnownField {
  return KNOWN_FIELD_TYPES.has(field.type);
}

export function isKnownBotBlock(block: BotBlock): block is BotKnownBlock {
  return KNOWN_BLOCK_KINDS.has(block.block);
}
